// pages/LoginPage.js
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import ErrorDisplay from '../components/ErrorDisplay'
import { getAppName } from '../utils/domainUtils'
import DynamicMetaTags from '../components/DynamicMetaTags'
import './Auth.css'

function LoginPage () {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [isLoading, setIsLoading] = useState(false)

  const { login, error, setError } = useAuth()
  const navigate = useNavigate()

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (!formData.email || !formData.password) {
      setError('Bitte füllen Sie alle Felder aus.')
      return
    }

    setIsLoading(true)
    setError(null)

    try {
      await login(formData.email, formData.password)
      navigate('/search')
    } catch (error) {
      // Fehler wird bereits im AuthContext behandelt
      console.error('Anmeldung fehlgeschlagen:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className='auth-container'>
      <DynamicMetaTags 
        pageTitle="Anmelden"
        description="Melden Sie sich an, um auf die KI-gestützte Wissensdatenbank zuzugreifen."
      />
      
      <div className='auth-card'>
        <h1>{getAppName()}</h1>
        <h2>Willkommen zurück</h2>
        <p style={{ 
          color: 'rgba(255, 255, 255, 0.7)', 
          marginBottom: '2rem', 
          fontSize: '0.95rem',
          marginTop: '-1rem'
        }}>
          Melden Sie sich an, um fortzufahren
        </p>

        <ErrorDisplay
          error={error}
          onDismiss={() => setError(null)}
        />

        <form onSubmit={handleSubmit} className='auth-form'>
          <div className='auth-form-group'>
            <label htmlFor='email'>E-Mail</label>
            <input
              type='email'
              id='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              placeholder='ihre.email@beispiel.de'
              disabled={isLoading}
              required
            />
          </div>

          <div className='auth-form-group'>
            <label htmlFor='password'>Passwort</label>
            <input
              type='password'
              id='password'
              name='password'
              value={formData.password}
              onChange={handleChange}
              placeholder='Ihr Passwort'
              disabled={isLoading}
              required
            />
          </div>

          <button
            type='submit'
            className='btn-primary auth-btn'
            disabled={isLoading}
          >
            {isLoading ? 'Anmeldung läuft...' : 'Anmelden'}
          </button>
        </form>

        <div className='auth-links'>
          <p>
            Noch kein Konto?
            <Link to='/register' className='auth-link'>
              Hier registrieren
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
